import { nameOfFactory } from "@utils";
import { ReadClientDTO } from "@models/reviews/entities/client";
import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import { TextOverflowEllipsis } from "@pages/platform-analysis/components/text-overflow-ellipsis";
import { SHAvatar, SHStack, SHTypography } from "@components/design-systems";
import { StatusBadge } from "@components/status-badge";
import { ClientStatus } from "@models/reviews/enums/status";
import React from "react";
import { FamilyGroupFilterOptions } from "@pages/platform-analysis/constant";

export const FamilyGroupNameOfFactory = nameOfFactory<ReadClientDTO>();
export const FamilyGroupColumnHelper = createColumnHelper<ReadClientDTO>();

interface GetFamilyGroupTableColumnDefsProps {
  renderItemActions: (itemData: ReadClientDTO) => React.ReactNode;
}

export const getFamilyGroupTableColumnDefs = ({
  renderItemActions,
}: GetFamilyGroupTableColumnDefsProps): ColumnDef<ReadClientDTO, any>[] => {
  const columnHelper = FamilyGroupColumnHelper;
  return [
    columnHelper.accessor("name", {
      header: "Family group name",
      cell: (props) => (
        <TextOverflowEllipsis fontWeight="bold" value={props.cell.getValue()} />
      ),
      enableColumnFilter: false,
      meta: {
        sx: {
          minWidth: "200px",
          width: "calc((100% - 592px)*0.6)",
          padding: "0 16px !important",
        },
      },
    }),
    columnHelper.accessor("numberOfReviews", {
      header: "Number of reviews",
      cell: (props) => (
        <SHTypography variant="body4">{props.cell.getValue()}</SHTypography>
      ),
      enableColumnFilter: false,
      meta: {
        sx: {
          minWidth: "150px",
          width: "calc((100% - 592px)*0.3)",
        },
      },
    }),
    columnHelper.accessor((row) => row, {
      id: FamilyGroupNameOfFactory("adviserName"),
      header: "Adviser",
      enableColumnFilter: false,
      cell: (props) => {
        return (
          <SHStack direction={"row"} alignItems={"center"}>
            <SHAvatar
              width={"24px"}
              height={"24px"}
              src={props.cell.getValue().adviserAvatarUrl}
            />
            <TextOverflowEllipsis
              value={props.cell.getValue().adviserName}
              sx={{
                marginLeft: "5px",
                minWidth: "100%",
              }}
            />
          </SHStack>
        );
      },
      meta: {
        sx: {
          minWidth: "180px",
          width: "calc((100% - 592px)*0.3)",
          padding: "0 16px !important",
        },
      },
    }),
    columnHelper.accessor("status", {
      header: "Status",
      cell: (props) => (
        <StatusBadge
          style={{ width: "101px", fontSize: "13px" }}
          status={props.cell.getValue() as ClientStatus}
        />
      ),
      meta: {
        filterData: FamilyGroupFilterOptions,
        sx: {
          width: "180px",
          padding: "0 16px !important",
        },
      },
    }),
    columnHelper.accessor((row) => row, {
      id: "actionCol",
      header: "Action",
      enableColumnFilter: false,
      enableSorting: false,
      cell: (props) => {
        return renderItemActions(props.row.original);
      },
      meta: {
        sx: {
          width: "192px",
        },
      },
    }),
  ];
};
